export default "__VITE_ASSET__c46de08e__"